import Instance from '../../../Axios';

// New Actions for the app

const GetReservas = () => async (dispatch) => {
  await Instance()
    .get(`/backend/reservas`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_RESERVAS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetReservas;
